import { render, staticRenderFns } from "./BadGateway.vue?vue&type=template&id=7bb7c836&scoped=true&"
import script from "./BadGateway.vue?vue&type=script&lang=js&"
export * from "./BadGateway.vue?vue&type=script&lang=js&"
import style0 from "./BadGateway.vue?vue&type=style&index=0&id=7bb7c836&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb7c836",
  null
  
)

export default component.exports